import {
  DateRange,
  getFormattedValueFromDateRange,
} from 'components/organisms/projects-report/common/range-picker/types';
import {
  TermSeparator,
  ValueSeparator,
} from 'components/organisms/tasks/filters/separators';
import { RoutePaths } from 'constant';

export const getUrlForPeopleTimesheetReport = (
  userId: number,
  range: DateRange,
): string => {
  const [startDate, endDate] = getFormattedValueFromDateRange(range);

  return `${RoutePaths.timesheetReports}/users/${userId}?range=custom${TermSeparator}${startDate}${ValueSeparator}${endDate}`;
};
